export default __webpack_public_path__ + "static/media/Answered.01cd7f50.svg";